import { PAYMENT_METHODS } from 'src/common/enums';
export * from './cardconnect';
export * from './cybersource';

export interface BreakdownItem {
  label: string;
  value: number;
  key?: string;
}

export interface PaymentFeesSummary {
  total?: number;
}

export interface PaymentFees {
  ccFee?: number | null;
  ccTotal?: number | null;
  achFee?: number | null;
  achTotal?: number | null;
  checkFee?: number | null;
  checkTotal?: number | null;
  breakdown?: BreakdownItem[];
  summary?: PaymentFeesSummary;
}

export interface PaymentSuccessInfo {
  id?: string;
  paymentConfirmation?: string;
}

export interface PaymentState {
  isInitialized?: boolean;
  isLoading?: boolean;
  paymentCheckFailed?: boolean;
  paymentFees?: PaymentFees;
  paymentID?: number | string | null;
  paymentSuccesInfo?: PaymentSuccessInfo | null;
  formData?: unknown; // Shared information across be/fe depends on payment provider
  selectedPaymentMethod?: PAYMENT_METHODS;
  signatoryName?: string | null;
  status?: string;
}

export enum PAYMENT_PROVIDER {
  CARD_CONNECT = 'cardconnect',
  CYBERSOURCE = 'cybersource',
  GENERIC = 'generic',
  INTELLIPAY = 'intellipay',
  STRIPE = 'stripe',
  XPRESS_BILL_PAY = 'xpressbillpay',
  HEARTLAND = 'heartland',
}

export type PaymentMethod =
  (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS];
